<template>
  <div>
    <div
      :class="{
        'max-h-[140px]': collapsed && props.totalFacets && props.totalFacets > 4
      }"
      class="overflow-hidden"
    >
      <slot />
    </div>
    <div
      v-if="collapsed && props.totalFacets && props.totalFacets > 4"
      class="flex items-center cursor-pointer pt-2"
      @click="collapsed = !collapsed"
    >
      <Icon name="plus" class="-ml-1" />
      <div class="font-bold">{{ $t('products.more') }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
const collapsed = ref(true)
const props = defineProps<{
  totalFacets?: number
}>()
</script>
